import { createStore } from 'vuex'
import SettingsModule from '../store/modules/settings-module'
import AppModule from '../store/modules/app-module'

export const store = createStore({
    state: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
        SettingsModule,
        AppModule,
    }
})
